import { PropsWithChildren, FC } from 'react'
import { Popover as AntPopover } from 'antd'
import { PopoverProps } from 'antd/lib/popover'

import { mouseEnterDelay, mouseLeaveDelay } from '../constants'

const Popover: FC<PropsWithChildren<PopoverProps>> = props => {
    const { children, ...popoverProps } = props

    return (
        <AntPopover
            {...popoverProps}
            mouseEnterDelay={mouseEnterDelay}
            mouseLeaveDelay={mouseLeaveDelay}
        >
            {children}
        </AntPopover>
    )
}

export default Popover
